import { css, keyframes } from 'styled-components';
import { IMixinsFontFace } from '../../@types/model/style';

export const mixinBlind = css`
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  clip: rect(0 0 0 0);
`;

export const mixinBlindScroll = css`
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const mixinScrollX = css`
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;

  ${mixinBlindScroll};
`;

export const mixinSafeArea = (property: string, value = 0) => `
  ${property}: ${value}px;
  ${property}: calc(env(safe-area-inset-bottom) + ${value ? value : 0}px);
  ${property}: calc(constant(safe-area-inset-bottom) + ${value ? value : 0}px);
`;

export const mixinPlaceholder = (color: string) => `
  &::-webkit-input-placeholder {
    color: ${color};
  }
  &:-moz-placeholder {
    color: ${color};
  }
  &:-ms-input-placeholder {
    color: ${color};
  }
  &::placeholder {
    color: ${color};
  }
`;

export const mixinEllipsis = (line = 1) => `
  ${line === 1
    ? `overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;`
    : `display: block;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-wrap: break-word;
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;`
  }
`;

export const mixinFontFace = ({ family, weight, style, src, svg }: IMixinsFontFace): string => {
  return `@font-face {
      font-family: ${family};
      font-weight: ${weight};
      font-style: ${style};
      src: url('//image.msscdn.net/${src}.eot');
      src: local('☺'), url('//image.msscdn.net/${src}.eot?#iefix') format('embedded-opentype'),
        url('//image.msscdn.net/${src}.woff2') format('woff2'), url('//image.msscdn.net/${src}.woff') format('woff'),
        url('//image.msscdn.net/${src}.ttf') format('truetype'),
        url('//image.msscdn.net/${src}.svg#${svg}') format('svg');
    }`;
};

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const roundAll = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const likeActive = keyframes`
  0% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
`;

export const getGenderColor = (gender: string) => {
  if (gender === 'M') {
    return 'black';
  } else if (gender === 'W') {
    return '#685bba';
  } else if (gender === 'K') {
    return '#f93';
  } else {
    return '#390';
  }
};

export const blind = () => `
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  clip: rect(0 0 0 0);
`;

export const mixinPositionCenter = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;